import { SearchParameter } from './searchParameter';
export class SearchtermSearchParameter extends SearchParameter {
    public searchterm: string = "";
}